import '../css/styles.css';
import React from 'react';
import NavButton from '../components/NavButton';
import HoverNavButton from '../components/HoverNavButton';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';

function Home(){
    const refContainer = useRef(null);
    const navigate = useNavigate();
    const [heroImg, setHeroImg] = useState('/img/background.png');
    const [buttonWidth, setButtonWidth] = useState("25%");
    const [buttonHeight, setButtonHeight] = useState("400px");
    const solutions = [
        "All Ceramic",
        "PFM",
        "Implants",
        "Full Gold",
        "3D Printing",
        "Milling",
        "Long Term Temps",
        "Full Arch Zirconia",
        "Tech Info",
    ]; 

    const solutionsImg = [
        "/img/all-ceramic.png",
        "/img/porcelain-fused-to-metal.png",
        "/img/implant.png",
        "/img/IMG_3693.png",
        "/img/3d-printing.png",
        "/img/milling.png",
        "/img/long-term-temps.png",
        "/img/full-arch-zirconia.png",
        "/img/tech-info.png"
    ]

    useEffect(() => {
        refContainer.current.scrollIntoView({behavior: 'smooth'});
    }, []);

    useEffect(() => {
        const updateHero = () => {
            if(window.innerWidth <= 440) {
                setHeroImg("/img/mobile-test-bg.png");
            } else {
                setHeroImg("/img/test-bg3.png");
            }
        };
        updateHero();
        window.addEventListener('resize', updateHero);
        return()=> window.removeEventListener("resize", updateHero);
    })

    useEffect(() => {
        const updateButtonWidth = () => {
            if(window.innerWidth <= 440){
                setButtonWidth("90%");
                setButtonHeight("12.5rem");
            } else if(window.innerWidth <= 1300){
                setButtonWidth("45%");
                setButtonHeight("400px");
            } else {
                setButtonWidth("25%");
                setButtonHeight("400px");
            }
        };

        updateButtonWidth();
        window.addEventListener("resize", updateButtonWidth);
        return () => window.removeEventListener("resize", updateButtonWidth);
    }, [])

    return(
        <div>
            <NavBar/>
            <div className='hero'>
                <img src={heroImg} className='hero-bg' alt="background-img" />
                    <div className='hero-overlay'>
                        <div className='home-intro' ref={refContainer}>
                            <div className='intro' >
                                <h2>The Crown/Bridge and Implant Specialists</h2>
                            </div>
                            <h3 className='stencil'>Art Through Passion</h3>
                            <div className='intro-buttons'>
                                <HoverNavButton text="View Our Work" width='40%' link="/projects" height='200px' hoverImg="/img/temp-gallery.jpg"/>
                                <HoverNavButton text="Request a Special Offer" width='40%' height='200px' link="/request-special-offer" hoverImg="/img/temp-gallery-2.jpg"/>
                                {/* <HoverNavButton text="View Our Work" width='40%' link="/projects" height='200px'/> */}
                                {/* <NavButton text="View Our Work" width="40%" link="/projects" height="200px" transparentText/> */}
                                {/* <HoverNavButton text="Request a Special Offer" width='40%' height='200px' link="/request-special-offer"/> */}
                                {/* <NavButton text='Request a Special Offer' width='40%' height='200px' link='/request-special-offer' transparentText/> */}
                            </div>
                            
                        </div>
                    </div>
                    
                </div>
            <main className='home-main'>
                <div className='about-zeiss'>
                    <img src='/img/zeiss.png' style={{width: '7.5rem'}} className='zeiss-logo' />
                    <p className='about-zeiss-text'><span>All restorations manufactured at Osseo are fit adjusted and inspected using Zeiss Optic microscopes, producing the sharpest, most precise margins in the industry.</span></p>
                </div>
                <h2 style={{textAlign:  'center'}}>Learn About our Restorations</h2>
                
                <div className='button-grid'>
                    {solutions.map((text, index) => {
                        const slug = text
                            .toLowerCase()
                            .replace(/[^a-z-]/g, '');

                        const link = text === "Tech Info" ? "/tech-info" : `/gallery/${slug}`;

                        return (
                            <NavButton
                            key={index}
                            text={text}
                            img={solutionsImg[index]}
                            link={link}
                            width={buttonWidth}
                            height={buttonHeight}
                            />
                        );
                    })}
                    
                </div>
            </main>
            <Footer/>
            
        </div>
    )
}
export default Home;